"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Referral = createSVGIcon(
  <>
    <path
      d="M11.55 11.625h7.269M11.55 16.574h7.269M11.55 21.523h7.269"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="m7.11 16.068-6.057 4.928v22.9h37.955v-22.9l-6.147-5.242v10.005"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M33.055 5.195H7.006v20.643m6.717 4.661h12.339"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="m38.873 21.57-13.26 9.359 13.395 12.968M1.053 21.57 14.45 30.93 1.053 43.897"
      stroke="currentColor"
    />
    <path
      d="m39.759 3.513-13.622 8.679-2.785 4.647 5.389-.56 13.621-8.68c2.046-1.303 3.531-2.728 2.447-4.43-1.098-1.724-3.005-.96-5.05.344Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path stroke="currentColor" d="M39.697 3.552 42.301 7.638" />
    <path stroke="currentColor" d="M36.707 5.059 39.311 9.146" />
  </>,
  "Referral",
  {
    viewBox: "0 0 47 45",
    titleAccess: "Referral",
    fill: "none",
    className: legacyIconCls(),
  }
);
